import React, { useState, useMemo } from "react";
import Button from "components/Elements/Button/Button.js";
import { useToasts } from "react-toast-notifications";
import { useContent } from "contexts/contentContext/contentContext.js";
import FilesFormats from "./FilesFormats.js";
import AfterUploadCompletes from "./AfterUploadCompletes.js";
import FormNotifications from "./FormNotifications.js";
import Security from "./Security.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import RecipientEmailSettings from "./RecipientEmailSettings.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import FormLanguage from "./FormLanguage.js";
import DesignTool from "../DesignTool.js";
import { useUser } from "contexts/userContext/userContext.js";
import GetTransformedDate from "utils/dateViewTransformer.tsx";
import parse from "html-react-parser";
import { LinkToNewTab } from "components/Elements/Link/Link.js";

import "./EmbedFormSettings.scss";

const EmbedFormSettingsNew = ({
  emailToReceiveFiles, //Settings
  setEmailToReceiveFiles,
  uploadFilesLimit,
  setUploadFilesLimit,
  fileSizeLimit,
  setFileSizeLimit,
  manuallyDeleteCheckbox,
  setManuallyDeleteCheckbox,
  automaticallyDeleteCheckbox,
  setAutomaticallyDeleteCheckbox,
  daysToDelete,
  setDaysToDelete,
  uploadAnyFormatsCheckbox,
  setUploadAnyFormatsCheckbox,
  allowFolowingFormatsCheckbox,
  setAllowFolowingFormatsCheckbox,
  denyForamtsCheckbox,
  setDenyForamtsCheckbox,
  fileFormats,
  setFileFormats,
  potentialCustomers,
  setPotentialCustomers,
  customersFilesDownloaded,
  setCustomersFilesDownloaded,
  orderConfirmation,
  setOrderConfirmation,
  sendEmailToRecipients,
  setSendEmailToRecipients,
  displayLink,
  setDisplayLink,
  displaySendAnotherEmail,
  setDisplaySendAnotherEmail,
  thankyouPageRedirect,
  setThankyouPageRedirect,
  redirectLink,
  setRedirectLink,
  protectFormWithPassword,
  setProtectFormWithPassword,
  passwordForm,
  setPasswordForm,
  setInvalidFilesFormat,
  invalidFilesFormat,
  setInvalidAlert,
  invalidAlert,
  invalidEmailReceiveFiles,
  setInvalidEmailReceiveFiles,
  languageIndex,
  formLanguage,
  setFormLanguage,
  settitleDropDown,
  setDropDownLanguage,
  setUpdateBeforeSave,
  formWidth,
  setFormWidth,
  formBackgroundColor,
  setFormBackgroundColor,
  setDirectionForm,
  allowAccess,
  setAllowAccess,
  emptyPassword,
  setEmptyPassword,
  emptyOrInvalidUrl,
  setEmptyOrInvalidUrl,
  displayToSubUsers,
  setDisplayToSubUsers,
  formMaxHeight,
  setFormMaxHeight,
  deleteMailLink,
  setDeleteMailLink,
  viewMode,
  setViewMode,
  displayTypeSubUsers,
  setDisplayTypeSubUsers,
}) => {
  const { addToast } = useToasts();
  const { getUserData, isLoggedIn, isSubscribed } = useUser();
  const userData = getUserData();
  const { getTextByKey, getDirection } = useContent();
  const [closeClass, setCloseClass] = useState(false);
  const [activeStep, setActiveStep] = useState(null);
  const [subscribersConst, setSubscribersConst] = useState(null);
  const [subscriberButton, setSubscriberButton] = useState(null);
  const [subscriberLink, setSubscriberLink] = useState(null);

  const settingsOptions = [
    {
      title: "settings-design",
      tooltip: "form-desgin-option-tooltip",
    },
    {
      title: "email-receive-files",
      tooltip: "email-receive-files-tooltip",
    },
    {
      title: "create-form-language",
      tooltip: "create-form-language-tooltip",
    },
    {
      title: "settings-files",
      tooltip: "",
    },

    {
      title: "settings-notifications",
      tooltip: "",
    },
    {
      title: "settings-security",
      tooltip: "",
    },
    {
      title: "after-upload-complete",
      tooltip: "",
    },
  ];

  const renderSettingsPart = (item) => {
    switch (item.title) {
      case "create-form-language":
        return (
          <FormLanguage
            languageIndex={languageIndex}
            formLanguage={formLanguage}
            setFormLanguage={setFormLanguage}
            settitleDropDown={settitleDropDown}
            setDropDownLanguage={setDropDownLanguage}
            setUpdateBeforeSave={setUpdateBeforeSave}
            setDirectionForm={setDirectionForm}
          />
        );
      case "settings-design":
        return (
          <div className="tools-bar-new">
            <DesignTool
              formWidth={formWidth}
              setFormWidth={setFormWidth}
              formBackgroundColor={formBackgroundColor}
              setFormBackgroundColor={setFormBackgroundColor}
              setUpdateBeforeSave={setUpdateBeforeSave}
              formMaxHeight={formMaxHeight}
              setFormMaxHeight={setFormMaxHeight}
            />
          </div>
        );
      case "email-receive-files":
        return (
          <RecipientEmailSettings
            invalidEmailReceiveFiles={invalidEmailReceiveFiles}
            setInvalidEmailReceiveFiles={setInvalidEmailReceiveFiles}
            invalidAlert={invalidAlert}
            setEmailToReceiveFiles={setEmailToReceiveFiles}
            emailToReceiveFiles={emailToReceiveFiles}
            setUpdateBeforeSave={setUpdateBeforeSave}
          />
        );
      case "settings-files":
        return (
          <FilesFormats
            uploadFilesLimit={uploadFilesLimit}
            setUploadFilesLimit={setUploadFilesLimit}
            manuallyDeleteCheckbox={manuallyDeleteCheckbox}
            setManuallyDeleteCheckbox={setManuallyDeleteCheckbox}
            automaticallyDeleteCheckbox={automaticallyDeleteCheckbox}
            setAutomaticallyDeleteCheckbox={setAutomaticallyDeleteCheckbox}
            uploadAnyFormatsCheckbox={uploadAnyFormatsCheckbox}
            setUploadAnyFormatsCheckbox={setUploadAnyFormatsCheckbox}
            allowFolowingFormatsCheckbox={allowFolowingFormatsCheckbox}
            setAllowFolowingFormatsCheckbox={setAllowFolowingFormatsCheckbox}
            denyForamtsCheckbox={denyForamtsCheckbox}
            setDenyForamtsCheckbox={setDenyForamtsCheckbox}
            daysToDelete={daysToDelete}
            setDaysToDelete={setDaysToDelete}
            setFileSizeLimit={setFileSizeLimit}
            fileSizeLimit={fileSizeLimit}
            setFileFormats={setFileFormats}
            fileFormats={fileFormats}
            setInvalidFilesFormat={setInvalidFilesFormat}
            invalidFilesFormat={invalidFilesFormat}
            setInvalidAlert={setInvalidAlert}
            setUpdateBeforeSave={setUpdateBeforeSave}
            invalidAlert={invalidAlert}
          />
        );
      case "settings-notifications":
        return (
          <FormNotifications
            potentialCustomers={potentialCustomers}
            setPotentialCustomers={setPotentialCustomers}
            customersFilesDownloaded={customersFilesDownloaded}
            setCustomersFilesDownloaded={setCustomersFilesDownloaded}
            orderConfirmation={orderConfirmation}
            setOrderConfirmation={setOrderConfirmation}
            sendEmailToRecipients={sendEmailToRecipients}
            setSendEmailToRecipients={setSendEmailToRecipients}
            setUpdateBeforeSave={setUpdateBeforeSave}
          />
        );
      case "settings-security":
        return (
          <Security
            protectFormWithPassword={protectFormWithPassword}
            setProtectFormWithPassword={setProtectFormWithPassword}
            passwordForm={passwordForm}
            setPasswordForm={setPasswordForm}
            allowAccess={allowAccess}
            setAllowAccess={setAllowAccess}
            setUpdateBeforeSave={setUpdateBeforeSave}
            emptyPassword={emptyPassword}
            setEmptyPassword={setEmptyPassword}
            displayToSubUsers={displayToSubUsers}
            setDisplayToSubUsers={setDisplayToSubUsers}
            displayTypeSubUsers={displayTypeSubUsers}
            setDisplayTypeSubUsers={setDisplayTypeSubUsers}
          />
        );
      case "after-upload-complete":
        return (
          <AfterUploadCompletes
            displayLink={displayLink}
            setDisplayLink={setDisplayLink}
            displaySendAnotherEmail={displaySendAnotherEmail}
            setDisplaySendAnotherEmail={setDisplaySendAnotherEmail}
            thankyouPageRedirect={thankyouPageRedirect}
            setThankyouPageRedirect={setThankyouPageRedirect}
            redirectLink={redirectLink}
            setRedirectLink={setRedirectLink}
            setUpdateBeforeSave={setUpdateBeforeSave}
            emptyOrInvalidUrl={emptyOrInvalidUrl}
            setEmptyOrInvalidUrl={setEmptyOrInvalidUrl}
            deleteMailLink={deleteMailLink}
            setDeleteMailLink={setDeleteMailLink}
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
        );
      default:
        break;
    }
    return item.component;
  };

  const returnSettingsOptions = () => {
    setCloseClass(true);
    setTimeout(() => {
      setCloseClass(false);
      setActiveStep(null);
    }, 500);
  };

  const setActiveSettings = (item) => {
    setCloseClass(true);
    setTimeout(() => {
      setCloseClass(false);
      setActiveStep(item);
    }, 500);
  };

  const returnToHomeSetitngs = () => {
    if (activeStep.title === "settings-files") {
      if (invalidFilesFormat || invalidAlert) {
        // addToast(invalidAlert, {
        //   appearance: "error",
        // });
      } else {
        returnSettingsOptions();
      }
    } else if (activeStep.title === "email-receive-files") {
      if (invalidEmailReceiveFiles || invalidAlert) {
        // addToast(getTextByKey("invalid-email-address"), {
        //   appearance: "error",
        // });
      } else {
        returnSettingsOptions();
      }
    } else if (activeStep.title === "settings-security") {
      if (protectFormWithPassword && !passwordForm) {
        // addToast(getTextByKey("empty-password"), {
        //   appearance: "error",
        // });
        setEmptyPassword(true);
      } else {
        returnSettingsOptions();
      }
    } else if (activeStep.title === "after-upload-complete") {
      if (thankyouPageRedirect && !redirectLink) {
        setEmptyOrInvalidUrl(true);
      } else {
        returnSettingsOptions();
      }
    } else {
      returnSettingsOptions();
    }
  };

  const renderSubscrioptionExpiredAlert = (diffDays) => {
    let text = getTextByKey("subscription-expired-text-create-form");
    let dateToDelete = new Date(userData.Subscribtion_Expired);
    dateToDelete.setDate(dateToDelete.getDate() + 14);
    let beautifyDeleteDate = GetTransformedDate({ date: dateToDelete });
    let dateExpired = GetTransformedDate({
      date: userData.Subscribtion_Expired,
    });
    text = text.replace("#DATE#", dateExpired);
    text = text.replace("#day-date#", beautifyDeleteDate);

    return parse(text);
  };

  //Text before 30 days expired
  const renderSubscriptionBeforeExpiredAlert = (diffDays) => {
    let subKey = getTextByKey("subscription-about-to-expired-short-alert");
    subKey = subKey.replace("#DAYS#", diffDays);
    return subKey;
  };

  useMemo(() => {
    if (isLoggedIn()) {
      if (isSubscribed()) {
        if (userData.Subscribtion_Expired) {
          //check if userData.Subscribtion_Expired is less than 30 days from now (only if the user is/was subscribed)
          const subExpiredDate = new Date(userData.Subscribtion_Expired);
          const today = new Date();
          const diffTime = Math.abs(subExpiredDate - today);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays <= 30) {
            const subText = renderSubscriptionBeforeExpiredAlert(diffDays);
            setSubscribersConst(subText);
            setSubscriberButton(getTextByKey("renew-subscription-text"));
            setSubscriberLink("plans");
          }
        }
      } else {
        //check if expired date is not less than 14 days
        if (userData.Subscribtion_Expired) {
          const expireDate = new Date(userData.Subscribtion_Expired);
          const today = new Date();
          const diffTime = Math.abs(today - expireDate);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays < 14) {
            const newText = renderSubscrioptionExpiredAlert(diffDays);
            setSubscribersConst(newText);
            setSubscriberButton(getTextByKey("renew-subscription-text"));
            setSubscriberLink("plans");
          } else {
            setSubscribersConst(getTextByKey("upgrade-premium-text"));
            setSubscriberButton(getTextByKey("see-plans"));
            setSubscriberLink("plans");
          }
        } else {
          setSubscribersConst(getTextByKey("upgrade-premium-text"));
          setSubscriberButton(getTextByKey("see-plans"));
          setSubscriberLink("plans");
        }
      }
    }
  }, [isLoggedIn()]);
  return (
    <div className={`embed-form-settings`}>
      <div className="settings-container">
        {activeStep ? (
          <div className={`settings ${closeClass ? "close-animation" : ""}`}>
            <div onClick={() => returnToHomeSetitngs()} className="part-title">
              <Tooltip
                id={"close-settings"}
                tooltipTextKey={"back-text"}
                //hardPositioned
                bottom
              >
                <Icon
                  iconClass={"arrow-icon"}
                  name={`arrow-${getDirection() === "ltr" ? "left" : "right"}`}
                />
              </Tooltip>

              <div className="settings-title">
                <h2>{getTextByKey(activeStep.title)}</h2>
                {activeStep.tooltip && (
                  <Tooltip
                    id={activeStep.tooltip}
                    tooltipTextKey={activeStep.tooltip}
                    //hardPositioned
                    end
                  >
                    <Icon name="question-circle" iconClass="tooltip-question" />
                  </Tooltip>
                )}
              </div>
            </div>
            {renderSettingsPart(activeStep)}
          </div>
        ) : (
          <>
            <div
              className={`settings-list ${closeClass ? "close-animation" : ""}`}
            >
              <div className="settings-list-title">
                <h2>{getTextByKey("settings")}</h2>
              </div>
              <ul>
                {settingsOptions.map((item, i) => (
                  <li
                    key={i}
                    className="settings-part"
                    onClick={() => setActiveSettings(item)}
                  >
                    <div className="part-div">
                      <span>{getTextByKey(item.title)}</span>
                      <span>
                        <Icon
                          name={`arrow-${
                            getDirection() === "ltr" ? "right" : "left"
                          }`}
                        />
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
              {subscribersConst && (
                <>
                  <div className="subscription-alert">
                    <span className="subscription-text">
                      {subscribersConst}
                    </span>
                    {subscriberButton && (
                      <LinkToNewTab page={subscriberLink} isNewTab>
                        <Button className="new-button">
                          {subscriberButton}
                        </Button>
                      </LinkToNewTab>
                    )}
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EmbedFormSettingsNew;
